'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecentlyViewedStorage = exports.RecentlyViewedProducts = undefined;

var _carousel = require('./carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RecentlyViewedProducts = _carousel2.default;
exports.RecentlyViewedStorage = _storage2.default;
exports.default = _carousel2.default;